import { render } from "./NewMIInvestment.vue?vue&type=template&id=5aecb7d9&scoped=true"
import script from "./NewMIInvestment.vue?vue&type=script&lang=js"
export * from "./NewMIInvestment.vue?vue&type=script&lang=js"

import "./NewMIInvestment.vue?vue&type=style&index=0&id=5aecb7d9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5aecb7d9"

export default script